import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { setData, setSessionData } from "../redux/actions";
import { isAuthenticated } from "../utils/auth";

const ProtectedRoute = ({ element }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.data);
  const session = useSelector((state) => state.session.data);

  return isAuthenticated(user) ? (
    React.cloneElement(element, {
      userData: user,
      setData: (payload) => dispatch(setData(payload)),
      setSessionData: (payload) => dispatch(setSessionData(payload)),
      session,
    })
  ) : (
    <Navigate to="/sign-in" />
  );
};

export default ProtectedRoute;
